import { isMobile } from "react-device-detect";

export function chIsMobileBrowser() {
  return isMobile;
}